import { FunctionComponent } from 'react';
import { Label, Popup } from 'semantic-ui-react';
import React from 'react';

type SolicitationCheckerIndicatorViewProps = {
  hasMadeSolicitationBefore: boolean;
  hasSolicitedReviewedPro: boolean;
  hasActiveSolicitationToOtherPros: boolean;
  openOtherSolicitationPiMade: () => void;
};

export const SolicitationCheckerIndicatorView: FunctionComponent<
  SolicitationCheckerIndicatorViewProps
> = ({
  hasMadeSolicitationBefore,
  hasSolicitedReviewedPro,
  hasActiveSolicitationToOtherPros,
  openOtherSolicitationPiMade,
}) => {
  if (!hasMadeSolicitationBefore) {
    return (
      <Label size="mini" color="grey">
        Inconnu
      </Label>
    );
  }

  if (hasMadeSolicitationBefore && !hasSolicitedReviewedPro) {
    return (
      <Popup
        content="L'auteur de l'avis a fait une demande par mail à un autre pro"
        trigger={
          <Label
            onClick={openOtherSolicitationPiMade}
            style={{ cursor: 'pointer' }}
            size="mini"
            color="red"
          >
            Vérifier
          </Label>
        }
      />
    );
  }

  if (hasActiveSolicitationToOtherPros) {
    return (
      <Popup
        content="Il existe d'autres demandes actives, pensez à désactiver le suivi pour les demandes similaires sur d'autres pros"
        trigger={
          <Label
            onClick={openOtherSolicitationPiMade}
            style={{ cursor: 'pointer' }}
            size="mini"
            color="red"
          >
            Vérifier
          </Label>
        }
      />
    );
  }

  // All remaining solicitations are either inactive or all linked the the currently reviewed pro.
  return (
    <Label size="mini" color="green">
      Connu et à jour
    </Label>
  );
};
